import { Thead, Tr, Th } from '@patternfly/react-table'
import * as React from 'react'

import { RequireFeatureFlag } from '@app/components/feature_flags/require-feature-flag'
import { FeatureFlagId } from '@app/domain/feature-flags/feature-flags.interface'

export const InteractionListHeader = () => {
  return (
    <Thead>
      <Tr>
        <Th width={10}>Interaction</Th>
        <Th width={10}>Label</Th>
        <Th width={10}>Status</Th>
        <Th width={10}>Completion Details</Th>
        <RequireFeatureFlag feature={FeatureFlagId.RemoteInteraction}>
          <Th width={10}>Action</Th>
        </RequireFeatureFlag>
      </Tr>
    </Thead>
  )
}
